import { Control, Controller } from "react-hook-form";

import { AutocompleteValue } from "@mui/material";

import AutocompletePopper, {
  AutocompletePopperProps,
} from "./AutocompletePopper";

type Option = {
  id: string;
  name: string;
};

export type ControlledAutocompletePopperProps<
  T extends Option,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  TSubmitValue = string,
> = Omit<
  AutocompletePopperProps<T, Multiple, DisableClearable>,
  "value" | "onChange"
> & {
  control: Control<any>;
  name: string;
  getSubmitValue?: (
    value: AutocompleteValue<
      T | TSubmitValue,
      Multiple,
      DisableClearable,
      false
    >
  ) => AutocompleteValue<TSubmitValue, Multiple, DisableClearable, false>;
};

const ControlledAutocompletePopper = <
  T extends Option,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
>({
  control,
  name,
  getSubmitValue,
  ...props
}: ControlledAutocompletePopperProps<T, Multiple, DisableClearable>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <AutocompletePopper
          value={field.value}
          onChange={(_, value) => {
            const submitValue = getSubmitValue ? getSubmitValue(value) : value;
            field.onChange(submitValue);
          }}
          {...props}
        />
      )}
    />
  );
};

export default ControlledAutocompletePopper;
